@if(linkToHubReportNodeTexts.length > 0 && !order.businessReportCriteria?.uboTreeNodeID) {
    <lib-static-notice icon="link_2" [texts]="linkToHubReportNodeTexts" [text]="'orders.linkableToHubReportS' | transloco"></lib-static-notice>
}
<lib-validation-problems [saving$]="saving$"></lib-validation-problems>
<lib-order-business-report-criteria></lib-order-business-report-criteria>